'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XSSTooltip = exports.getSafeUrl = exports.isUnsafeUrl = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _Functions = require('../core/Functions');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Translatable = require('../decorators/Translatable');

var _Translatable2 = _interopRequireDefault(_Translatable);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-script-url */

var NOOP_HREF = 'javascript:void(0)';

// Match the protocol part of an absolute URL, e.g. "http:"
var PROTOCOL_REGEX = /^([^:]+):/;

// Whitespace and control characters are ignored, so we must strip them out
// eslint-disable-next-line no-control-regex
var IGNORED_PROTOCOL_CHARS_REGEX = /[\s\x00-\x1f]/g;

var isUnsafeUrl = exports.isUnsafeUrl = function isUnsafeUrl(href) {
  if (href && typeof href === 'string') {
    var protocolMatch = href.match(PROTOCOL_REGEX);
    if (!protocolMatch || href === NOOP_HREF) return false;
    if (protocolMatch[0].replace(IGNORED_PROTOCOL_CHARS_REGEX, '').toLowerCase() === 'javascript:') {
      return true;
    }
  }
  return false;
};

var getSafeUrl = exports.getSafeUrl = function getSafeUrl(href) {
  if (href && (typeof href === 'undefined' ? 'undefined' : _typeof(href)) === 'object' && typeof href.safeHref === 'string') {
    return href.safeHref;
  }
  return isUnsafeUrl(href) ? NOOP_HREF : href;
};

var XSSTooltip = exports.XSSTooltip = (0, _Controllable2.default)((0, _Translatable2.default)(_react2.default.createClass({
  displayName: 'XSSTooltip',

  propTypes: {
    children: _react.PropTypes.node,
    I18n: _react.PropTypes.object,
    onOpenChange: _react.PropTypes.func,
    open: _react.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {
      open: false
    };
  },
  handleClick: function handleClick(evt) {
    var _props = this.props,
        children = _props.children,
        onOpenChange = _props.onOpenChange,
        open = _props.open;

    // Trigger the child's original onClick, if it has one.

    var child = _react.Children.only(children);
    var originalOnClick = child.props.onClick;
    (0, _Functions.callIfPossible)(originalOnClick, evt);

    // Toggle the tooltip, unless the app prevents default click behavior.
    if (!evt.defaultPrevented) {
      onOpenChange((0, _SyntheticEvent2.default)(!open));
    }
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        I18n = _props2.I18n,
        open = _props2.open;


    return _react2.default.createElement(
      _UITooltip2.default,
      {
        open: open,
        title: I18n.text('salesUI.XSSTooltip.explanation'),
        use: 'danger'
      },
      _react2.default.cloneElement(children, {
        href: NOOP_HREF,
        onClick: this.handleClick
      })
    );
  }
})), ['open']);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/utils/UnsafeUrl.js
// module id = 55
// module chunks = 0